"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OverlayTitle: ()=>OverlayTitle
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const cn_cjs_namespaceObject = require("../../../utils/cn.cjs");
const index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../../IconButton/index.cjs");
const external_Popover_index_cjs_namespaceObject = require("../../Popover/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../../Text/index.cjs");
const external_OverlayTitle_variants_cjs_namespaceObject = require("./OverlayTitle.variants.cjs");
function OverlayTitle({ heading, subHeading, backIconName = 'arrow_back', popOverText = '', handleClose, slots = {
    container: '',
    root: '',
    headingClass: '',
    iconClass: '',
    subHeadingClass: ''
} }) {
    const { container, root, headingClass, subHeadingClass, iconClass } = (0, external_OverlayTitle_variants_cjs_namespaceObject.overlayTitleVariants)();
    const containerClasses = (0, cn_cjs_namespaceObject.cn)(container(), slots.container);
    const rootClasses = (0, cn_cjs_namespaceObject.cn)(root(), slots.root);
    const headingClasses = (0, cn_cjs_namespaceObject.cn)(headingClass(), slots.headingClass);
    const iconClasses = (0, cn_cjs_namespaceObject.cn)(iconClass(), slots.iconClass);
    const subHeadingClasses = (0, cn_cjs_namespaceObject.cn)(subHeadingClass(), slots.subHeadingClass);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: rootClasses,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                            iconName: backIconName,
                            type: "plainPrimary",
                            shadow: true,
                            size: "md",
                            "aria-label": "Close Drawer",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: headingClasses,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            className: "",
                            textStyle: "heading4",
                            children: heading
                        })
                    }),
                    popOverText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: iconClasses,
                        "data-testid": "overlay-title-popover-container",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Popover_index_cjs_namespaceObject.Popover, {
                            triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                palette: "primary",
                                className: "fill-none",
                                iconName: "info",
                                size: "24"
                            }),
                            side: "bottom",
                            children: popOverText
                        })
                    }) : null
                ]
            }),
            subHeading && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                textStyle: "body1",
                className: subHeadingClasses,
                children: subHeading
            })
        ]
    });
}
exports.OverlayTitle = __webpack_exports__.OverlayTitle;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OverlayTitle"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
